// SPDX-License-Identifier: MPL-2.0

/*
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */

export const ASSET_DIR = "/assets";
export const TOAST_DURATION_MS = 4000;
export const DATA_GRID_NOT_APPLICABLE_BG = "#222222";
export const PROGRAMMER_SELECTION_ID_TEXT_COLOR = "#ff0000";
